import { useProviderHub } from '@aries/aptos-defi';
import { Network } from '@aries/aptos-defi/common';
import {
  ActionSheet,
  CenterCol,
  Row,
  Txt,
} from '@aries/mobile-core/components';
import { openModal } from '@aries/mobile-core/Smoothy';
import { useTranslation } from '@aries/shared/locale';
import React from 'react';
import { ViewStyle } from 'react-native';

export const openNetworkSelect = () => {
  openModal({
    showHeader: false,
    renderContent: ({ close }) => <NetworkSelect close={close} />,
    showClose: false,
    height: 350,
  });
};

export const NetworkSelect: React.FC<{ close: () => void }> = ({
  close,
}) => {
  const { t } = useTranslation();
  const { list, changeNetwork, currentNetwork } = useProviderHub();

  return (
    <ActionSheet
      close={close}
      btns={list.map(({ name, desc, network }) => ({
        title: (
          <CenterCol gap={2}>
            <Row>
              <Txt h3 bold>
                {name}
              </Txt>
            </Row>
            <Txt c3 h2>
              {desc}
            </Txt>
          </CenterCol>
        ),
        type: name === currentNetwork.name ? 'primary' : 'ghost',
        onPress: () => {
          if (typeof window !== 'undefined' && window.location) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set(
              'network',
              network === Network.MAINNET ? 'mainnet' : 'testnet',
            );
            window.history.replaceState({}, '', newUrl.toString());
          }
          changeNetwork(name);
        },
      }))}
      cancelText={t`Cancel`}
      style={{ gap: 6 } as ViewStyle}
    />
  );
};
